import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { trioUITheme } from '@/styles/theme';

export type PTORequestWarningType =
  | 'REQUEST_APPROVED'
  | 'REQUEST_DENIED'
  | 'OVERLAPPING_REQUEST'
  | 'NOT_ENOUGH_HOURS';

const iconSize = { height: 12, width: 12 };

export const ptoRequestWarningIconsMapping: { [type in PTORequestWarningType]: JSX.Element } = {
  REQUEST_APPROVED: <CheckCircle sx={{ color: trioUITheme.colors.success, ...iconSize }} />,
  REQUEST_DENIED: <Cancel sx={{ color: trioUITheme.colors.warning, ...iconSize }} />,
  OVERLAPPING_REQUEST: <ErrorIcon sx={{ color: trioUITheme.colors['neutral-70'], ...iconSize }} />,
  NOT_ENOUGH_HOURS: <ErrorIcon sx={{ color: trioUITheme.colors.warning, ...iconSize }} />,
};

export const ptoRequestWarningTextMapping: { [type in PTORequestWarningType]: string } = {
  REQUEST_APPROVED: 'Request approved',
  REQUEST_DENIED: 'Request denied',
  OVERLAPPING_REQUEST: 'Overlapping PTO requests approved for the same dates',
  NOT_ENOUGH_HOURS: 'Not enough hours available for this request',
};

export const ptoRequestTextColorsMapping: { [type in PTORequestWarningType]: string } = {
  REQUEST_APPROVED: trioUITheme.colors['neutral-90'],
  REQUEST_DENIED: trioUITheme.colors['neutral-90'],
  OVERLAPPING_REQUEST: trioUITheme.colors['neutral-70'],
  NOT_ENOUGH_HOURS: trioUITheme.colors.warning,
};
